import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap, withLatestFrom } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { FloorStoreActions } from '../floor/index';

import { LocationsRouterStoreSelectors } from '../router/index';

@Injectable({ providedIn: 'root' })
export class FloorResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(LocationsRouterStoreSelectors.selectLocationHumanId).pipe(
      withLatestFrom(this.store.select(LocationsRouterStoreSelectors.selectBrandHumanId)),
      tap(([locationId, brandId]) => {
        if (locationId && brandId) {
          this.store.dispatch(
            FloorStoreActions.FloorResolverActions.floorsRequested({
              locationId: locationId,
              brandId: brandId,
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
